/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
  'use strict';

  function setLoadingState(container, isLoading) {
    container.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    container.querySelectorAll('[data-action="update-paid-shopping-bag-quantity"]').forEach(function(button) {
      button.disabled = isLoading;
    });
  }

  function refreshCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  }

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-action="update-paid-shopping-bag-quantity"]');

    if (!button || button.disabled) {
      return;
    }

    var container = button.closest('[data-paid-shopping-bag]');

    if (!container) {
      return;
    }

    var currentQuantity = parseInt(container.getAttribute('data-quantity'), 10) || 0;
    var nextQuantity = currentQuantity + (parseInt(button.getAttribute('data-change'), 10) || 0);
    var variantId = parseInt(container.getAttribute('data-variant-id'), 10);
    var itemKey = container.getAttribute('data-key');
    var status = container.querySelector('[data-paid-shopping-bag-status]');

    event.preventDefault();

    if (nextQuantity < 0 || !variantId) {
      return;
    }

    setLoadingState(container, true);
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    var requestUrl = itemKey ? window.routes.cartChangeUrl + '.js' : window.routes.cartAddUrl + '.js';
    var requestBody = itemKey ? {
      id: itemKey,
      quantity: nextQuantity
    } : {
      items: [{
        id: variantId,
        quantity: nextQuantity
      }]
    };

    fetch(requestUrl, {
      body: JSON.stringify(requestBody),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function(response) {
      if (!response.ok) {
        throw new Error('Unable to update paid shopping bag quantity.');
      }

      return response.json();
    }).then(function() {
      refreshCart();
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    }).catch(function() {
      setLoadingState(container, false);

      if (status) {
        status.textContent = '手提げ袋の数量を更新できませんでした。もう一度お試しください。';
      }

      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    });
  });
})();
